import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import React, { Component } from "react";
import JobCard from "./JobCard";
import { Link } from "react-router";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import * as colors from "material-ui/styles/colors";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import {
  AppBar,
  Card,
  CardTitle,
  FontIcon,
  IconMenu,
  IconButton,
  Drawer,
  MenuItem,
  Paper,
  Subheader,
  Dialog,
  FlatButton,
} from "material-ui";
import { NavigationMoreVert } from "material-ui/svg-icons";
import homeIcon from "../images/home_icon.png";
import documentUploaderIcon from "../images/document_uploader_icon.png";
import payrollEmaillerIcon from "../images/payroll_emailler_icon.png";
import upload8879Icon from "../images/upload_8879_icon.png";
import organizer_upload_icon from "../images/organizer_upload_icon.png";
import administrator_icon from "../images/administration-icon.png";
import qrIcon from "../images/qr_icon.png";
import sourceDocumentUpload from "../images/source_documents_small.png";
import ShowPackageList from "./documentUploader/ShowPackageList";
import QRCode from "./documentUploader/QRCode";

const buildInterval = 90000;
const updateInterval = 600000;
const emailDashboardToken = process.env.EMAIL_DASHBOARD_TOKEN;
const emailMock = process.env.EMAIL_MOCK;

export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navValue:
        this.props.token.user && this.props.token.user != "undefined"
          ? "Home"
          : "Login",
    };
    this.getVersion = this.getVersion.bind(this);
    this.checkVersion = this.checkVersion.bind(this);
    //this.showUpdateDialog = this.showUpdateDialog.bind(this);
    this.renderJob = this.renderJob.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.reloadWhenBackIsClicked = this.reloadWhenBackIsClicked.bind(this);
  }

  getVersion() {
    let url = `/api/unauth/appVersion`;
    let versionFetch = new Promise((resolve, reject) => {
      fetch(url, {}).then((res) => {
        if (res.status >= 200 && res.status < 300) resolve(res.json());
        else return versionFetch(url, {});
      });
    });
    return versionFetch;
  }

  checkVersion() {
    this.getVersion().then((json) => {
      if (localStorage.getItem("version") !== json.version) {
        localStorage.setItem("version", json.version);
        setTimeout(() => {
          //this.showUpdateDialog();
        }, buildInterval);
      }
    });
  }

  componentDidMount() {
    if (window.location.pathname == "/ShowPackageList") {
      this.setState({ navValue: "ShowPackageList" });
    } else if (window.location.pathname == "/job/Payroll/PayrollInput") {
      this.setState({ navValue: "PayrollInput" });
    } else if (window.location.pathname == "/job/Payroll/upload8879s") {
      this.setState({ navValue: "upload8879s" });
    } else if (window.location.pathname == "/QRCode") {
      this.setState({ navValue: "QRCode" });
    } else if (window.location.pathname == "/OrganizerUpload") {
      this.setState({ navValue: "OrganizerUpload" });
    } else if (window.location.pathname == "/SourceDocumentUpload") {
      this.setState({ navValue: "SourceDocumentUpload" });
    } else if (window.location.pathname == "/GenericPorter") {
      this.setState({ navValue: "GenericPorter" });
    } else if (window.location.pathname == "/Administration") {
      this.setState({ navValue: "Administration" });
    } else {
      if (!this.props.token.user || this.props.token.user == undefined) {
        this.setState({ navValue: "Login" });
      } else {
        this.setState({ navValue: "Home" });
      }
    }
    this.reloadWhenBackIsClicked();
  }
  handleClick() {
    const popup = document.createElement("div");
    popup.className = "popup";
    popup.innerHTML = `
				   <div class="popup-content">
				    <h3>Temporarily Unavailable</h3> 
				    <button class="close-btn">Close</button>
				  </div>`;
    document.body.appendChild(popup);
    const closeBtn = popup.querySelector(".close-btn");
    closeBtn.addEventListener("click", () => {
      document.body.removeChild(popup);
    });
  }

  redirectToEmailDashboard() {
    window.location = `/${emailDashboardToken}/email-dashboard`;
  }

  reloadWhenBackIsClicked() {
    window.addEventListener("pageshow", function (event) {
      var historyTraversal =
        event.persisted ||
        (typeof window.performance != "undefined" &&
          window.performance.getEntriesByType("navigation")[0].type ===
            "back_forward");
      if (historyTraversal && !window.reloaded) {
        // Handle page restore.
        window.reloaded = true;
        window.location.reload();
      }
    });
  }

  showUpdateDialog() {
    const title = "New Version Available";
    const content = [
      <p key="message">
        A new version of the application is available. It is highly recommended
        to stay up to date with the latest version. Click 'Update' to update
        right now, or click 'Wait' to close this dialog and continue working.
      </p>,
    ];

    const actions = [
      <FlatButton
        key="wait"
        label="Wait"
        onClick={this.props.closeDialog.bind(this)}
      />,
      <FlatButton
        key="update"
        label="Update"
        onClick={this.props.logOut.bind(
          this,
          encodeURIComponent(this.props.location.pathname),
        )}
      />,
    ];

    //this.props.openDialog(title, content, actions);
  }

  renderJob(job, i) {
    return (
      <div className="container-fluid" key={i}>
        <br />
        <JobCard
          title={job.title}
          link={job.link}
          performRoute={this.props.performRoute}
          color={job.color}
          titleColor={job.title_color}
          actions={job.card_actions}
        />
      </div>
    );
  }

  showEmailDashboard() {
    if (emailMock !== "disabled") {
      return (
        <MenuItem
          primaryText="Email Dashboard"
          onClick={this.redirectToEmailDashboard}
        />
      );
    }
  }

  render() {
    let { navValue } = this.state;
    let iconElementRight = (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <label style={{ color: "#FAFAFA", marginTop: 5 }}>
          {this.props.token.user ? this.props.token.user.name : ""}
        </label>
        <IconMenu
          iconButtonElement={
            <IconButton>
              <NavigationMoreVert color="#FAFAFA" />
            </IconButton>
          }
          anchorOrigin={{ horizontal: "right", vertical: "top" }}
          targetOrigin={{ horizontal: "right", vertical: "top" }}
        >
          <MenuItem primaryText="Sign out" onClick={this.props.logOut} />
          {this.showEmailDashboard()}
        </IconMenu>
      </div>
    );
    let title = <div>{this.props.appbar.title}</div>;
    return (
      <MuiThemeProvider muiTheme={getMuiTheme()}>
        <div className="app" style={{ height: "calc(100vh)" }}>
          <nav className="navbar-fixed-top">
            <AppBar
              title={"Document Porter"}
              style={{ background: "#2979ff" }}
              onLeftIconButtonTouchTap={this.props.toggleNav}
              iconElementRight={iconElementRight}
              showMenuIconButton={window.screen.width < 600 ? true : false}
            />
          </nav>
          <div
            id="sidebarMenu"
            className="bg-light sidebar"
            style={{ float: "left", width: "16.67%" }}
          >
            <div className="popupParent sidebar-sticky">
              {this.props.token.user ? (
                <ul className="nav nav-tabs">
                  <li className="tablinks">
                    <a
                      href="/Home"
                      className={`${navValue == "Home" ? "active" : ""}`}
                    >
                      <span>
                        <img src={homeIcon} />
                      </span>
                      Home
                    </a>
                  </li>
                  <li className="tablinks">
                    {/*<a className={`${navValue =='ShowPackageList'? 'active' : ''}`} href="/ShowPackageList"><span><img src={documentUploaderIcon}/></span>Email porter</a>*/}
                    <a
                      className={`${
                        navValue == "ShowPackageList" ? "active" : ""
                      }`}
                      onClick={this.handleClick}
                    >
                      <span>
                        <img src={documentUploaderIcon} />
                      </span>
                      Email porter
                    </a>
                  </li>
                  <li className="tablinks">
                    <a
                      className={`${
                        navValue == "PayrollInput" ? "active" : ""
                      }`}
                      href="/job/Payroll/PayrollInput"
                    >
                      <span>
                        <img src={payrollEmaillerIcon} />
                      </span>
                      Pay Stub Porter
                    </a>
                    {/*<a className={`${navValue == 'PayrollInput'? 'active' : ''}`} onClick={this.handleClick}> <span><img src={payrollEmaillerIcon}/></span>Pay Stub Porter</a>*/}
                  </li>
                  <li className="tablinks">
                    <a
                      className={`${navValue == "upload8879s" ? "active" : ""}`}
                      href="/job/Payroll/upload8879s"
                    >
                      <span>
                        <img src={upload8879Icon} />
                      </span>
                      8879 Porter
                    </a>
                  </li>
                  <li className="tablinks">
                    <a
                      className={`${navValue == "QRCode" ? "active" : ""}`}
                      href="/QRCode"
                    >
                      <span>
                        <img src={qrIcon} />
                      </span>
                      Engagement Letter Porter
                    </a>
                  </li>
                  <li className="tablinks">
                    <a
                      className={`${
                        navValue == "OrganizerUpload" ? "active" : ""
                      }`}
                      href="/OrganizerUpload"
                    >
                      <span>
                        <img src={organizer_upload_icon} />
                      </span>
                      Organizer Porter
                    </a>
                  </li>
                  <li className="tablinks">
                    <a
                      className={`${
                        navValue == "SourceDocumentUpload" ? "active" : ""
                      }`}
                      href="/SourceDocumentUpload"
                    >
                      <span>
                        <img src={sourceDocumentUpload} />
                      </span>
                      Source Document Porter
                    </a>
                  </li>
                  <li className="tablinks">
                    <a
                      className={`${
                        navValue == "GenericPorter" ? "active" : ""
                      }`}
                      href="/GenericPorter"
                    >
                      <span>
                        <img src={organizer_upload_icon} />
                      </span>
                      Generic Porter
                    </a>
                  </li>
                  <li className="tablinks">
                    <a
                      className={`${
                        navValue == "Administration" ? "active" : ""
                      }`}
                      href="/Administration"
                    >
                      <span>
                        <img src={administrator_icon} />
                      </span>
                      Administration
                    </a>
                  </li>
                </ul>
              ) : (
                <ul className="nav nav-tabs">
                  <li className="tablinks">
                    <a
                      href="/Login?redirect=%2FHome"
                      className={`${navValue == "Login" ? "active" : ""}`}
                    >
                      <span>
                        <img src={homeIcon} />
                      </span>
                      Home
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </div>
          /*
          <div
            className="col-md-10 col-lg-10 "
            style={{
              float: "right",
              marginLeft: "15%",
              top: "64px",
              background: "#ebeff2",
              height: "inherit",
            }}
          >
            {React.cloneElement(this.props.children, this.props)}
            <Dialog
              title={this.props.dialog.title}
              actions={this.props.dialog.actions}
              modal={this.props.dialog.modal}
              open={this.props.dialog.open}
              onRequestClose={this.props.closeDialog}
              autoScrollBodyContent={true}
            >
              {this.props.dialog.content}
            </Dialog>
          </div>
          */
        </div>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Main.js